import { reactive } from "vue";

export type ToastType = "success" | "error" | "info" | "warning";

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
  duration: number;
}

const toasts = reactive<Toast[]>([]);
let idCounter = 0;

// 全局移除函数
const remove = (id: number) => {
  const index = toasts.findIndex((t) => t.id === id);
  if (index > -1) {
    toasts.splice(index, 1);
  }
};

export function useNotification() {
  const show = (type: ToastType, message: string, duration: number = 5000) => {
    const id = ++idCounter;
    const toast: Toast = {
      id,
      type,
      message,
      duration,
    };
    toasts.push(toast);

    if (duration > 0) {
      setTimeout(() => {
        remove(id);
      }, duration);
    }
  };

  const notifySuccess = (message: string, duration?: number) => {
    show("success", message, duration);
  };

  const notifyError = (message: string, duration?: number) => {
    show("error", message, duration);
  };

  const notifyInfo = (message: string, duration?: number) => {
    show("info", message, duration);
  };

  const notifyWarning = (message: string, duration?: number) => {
    show("warning", message, duration);
  };

  return {
    toasts,
    show,
    notifySuccess,
    notifyError,
    notifyInfo,
    notifyWarning,
  };
}

// 导出 toasts 和 remove 供组件直接使用
export { toasts, remove };
